module.exports = __webpack_public_path__ + "img/city-offer-logo.6c8f08ad.svg";